var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.895a2.105 2.105 0 1 0 0 4.21 2.105 2.105 0 0 0 0-4.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.193a3.193 3.193 0 1 1 0-6.386 3.193 3.193 0 0 1 0 6.386m7.158-4.456H13.32a5.433 5.433 0 0 0-.666-1.605l1.3-1.3a.844.844 0 0 0 0-1.19l-.596-.597a.846.846 0 0 0-1.19 0l-1.3 1.3a5.447 5.447 0 0 0-1.606-.666V.842A.845.845 0 0 0 8.421 0H7.58a.845.845 0 0 0-.842.842V2.68a5.447 5.447 0 0 0-1.606.666l-1.3-1.3a.846.846 0 0 0-1.19 0l-.596.597a.844.844 0 0 0 0 1.19l1.3 1.3c-.302.49-.53 1.029-.666 1.605H.842A.845.845 0 0 0 0 7.579v.842c0 .463.379.842.842.842H2.68c.136.577.364 1.117.666 1.606l-1.3 1.3a.844.844 0 0 0 0 1.19l.596.596a.846.846 0 0 0 1.19 0l1.3-1.299c.49.302 1.029.53 1.606.666v1.836c0 .463.379.842.842.842h.842a.845.845 0 0 0 .842-.842v-1.836a5.438 5.438 0 0 0 1.606-.666l1.3 1.3a.846.846 0 0 0 1.19 0l.596-.597a.844.844 0 0 0 0-1.19l-1.3-1.3c.302-.49.53-1.029.666-1.606h1.837A.845.845 0 0 0 16 8.421V7.58a.845.845 0 0 0-.842-.842"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.37d6a7a0a235a60661362e27f7ecdfb3.svg";
export { ForwardRef as ReactComponent };